import { QueryClient } from '@tanstack/react-query';
import { isForbiddenError, shouldRetry } from '@/lib/http-errors';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      retry: shouldRetry,
      // Throw a permission denial so the router's error boundary renders the
      // access-denied screen; every other failure stays in `isError`.
      throwOnError: isForbiddenError,
    },
  },
});

export { queryClient };
